import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"
import errorsFactory from "@/api/errorsFactory"

export default {
	async fetchTemplates({ tenantId }) {
		const file1 = import(`@/modules/reports/templates/${tenantId}/index.js`)
		const file2 = import(`@/modules/reports/templates/_default/index.js`)

		const promise1 = file1
			.then(file => {
				return Promise.resolve({ data: file.default })
			})
			.catch(err => {
				return Promise.resolve(errorsFactory({ code: "no_data" }))
			})

		const promise2 = file2
			.then(file => {
				return Promise.resolve({ data: file.default })
			})
			.catch(err => {
				return Promise.resolve(errorsFactory({ code: "no_data" }))
			})

		return Promise.all([promise1, promise2]).then(template => {
			//find and return array with data
			return template.find(item => item.data)
		})
	},

	async numberOfIndividuals(variables) {
		const res = await gql({
			query: query.numberOfIndividuals,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "individuals"
		})
	},

	async readAllIndividuals(variables) {
		const res = await gql({
			query: query.readAllIndividuals,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "individuals"
		})
	},

	async numberOfCompanies(variables) {
		const res = await gql({
			query: query.numberOfCompanies,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "companies"
		})
	},

	async readAllCompanies(variables) {
		const res = await gql({
			query: query.readAllCompanies,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "companies"
		})
	},

	async numberOfPolicies(variables) {
		const res = await gql({
			query: query.numberOfPolicies,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "policies"
		})
	},

	async readAllQuotes(variables) {
		const res = await gql({
			query: query.readAllQuotes,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async readAllPolicies(variables) {
		const res = await gql({
			query: query.readAllPolicies,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async numberOfClaims(variables) {
		const res = await gql({
			query: query.numberOfClaims,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "claims"
		})
	},

	async readAllClaims(variables) {
		const res = await gql({
			query: query.readAllClaims,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	async readClaimRejectionSettings(variables) {
		const res = await gql({
			query: query.readClaimRejectionSettings,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
  },
  
  async numberOfCases(variables) {
		const res = await gql({
			query: query.numberOfCases,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "cases"
		})
	},

	async readAllCases(variables) {
		const res = await gql({
			query: query.readAllCases,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "cases"
		})
	},
}
